import React from "react";
import {
  Tbl,
  TblHead,
  TblHeadCell,
  TblHeadRow,
  TblBody,
  TblBodyRow,
  TblBodyCell,
} from "./BorderlessTable";
import { ICardElementWithChildren } from "backend/model/model";

type RenderCell = (props: { elem: ICardElementWithChildren }) => JSX.Element;
type RenderColumn = (props: { elem: ColumnDefinition }) => JSX.Element;
type RowClickHandler = (elem: ICardElementWithChildren) => void;
type TableElement = () => JSX.Element;
type ColumnDefinition = {
  title: string | RenderColumn;
  value: RenderCell;
  onRowClick?: RowClickHandler;
};

const DrillDownTable = (props: {
  width?: string;
  maxHeight?: string;
  columns: ColumnDefinition[];
  items: ICardElementWithChildren[];
}) => {
  const { columns, items } = props;
  return (
    <Tbl width={props.width} maxHeight={props.maxHeight}>
      <TblHead>
        <TblHeadRow>
          {columns.map((col) => {
            if (typeof col.title === "string") {
              return <TblHeadCell>{col.title}</TblHeadCell>;
            }
            const Title = col.title;
            return (
              <TblHeadCell>
                <Title elem={col} />
              </TblHeadCell>
            );
          })}
        </TblHeadRow>
      </TblHead>
      <TblBody>
        {items.map((item) => {
          return (
            <TblBodyRow key={item.id}>
              {columns.map((col) => {
                const Value = col.value;
                const { onRowClick } = col;
                return (
                  <TblBodyCell
                    onClick={() => {
                      if (onRowClick) {
                        onRowClick(item);
                      }
                    }}
                    style={{ cursor: onRowClick ? "pointer" : undefined }}
                  >
                    <Value elem={item} />
                  </TblBodyCell>
                );
              })}
            </TblBodyRow>
          );
        })}
      </TblBody>
    </Tbl>
  );
};

export default DrillDownTable;
